import React from 'react';
import { Typography, IconButton, Grid } from '@mui/material';
import { AddCircleRounded } from '@mui/icons-material';

export default function AddOptionButton({ onClick, isDisabled }) {
  return (
    <Grid container alignItems="center" justifyContent="flex-end" sx={{ right: '0' }}>
      <Grid item>
        <IconButton aria-label="add-button" sx={{ float: 'right', marginBottom: '-22px' }} disabled={isDisabled}>
          <AddCircleRounded sx={{ color: isDisabled ? '#d3d3d3' : '#055f48' }} onClick={onClick} />
        </IconButton>
      </Grid>
      <Grid item>
        <Typography sx={{ fontSize: 14, marginBottom: '-25px', marginTop: '2px' }}>
          Add Option - up to 5
        </Typography>
      </Grid>
    </Grid>
  );
}
